module.exports = __webpack_public_path__ + "img/laptop.ed6d65e6.jpg";